'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AppBar = require('./AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AppBar2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/AppBar/index.js
 ** module id = 213
 ** module chunks = 0
 **/